import { render, staticRenderFns } from "./DigitMetric.vue?vue&type=template&id=196b1324&scoped=true&"
import script from "./DigitMetric.vue?vue&type=script&lang=js&"
export * from "./DigitMetric.vue?vue&type=script&lang=js&"
import style0 from "./DigitMetric.vue?vue&type=style&index=0&id=196b1324&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "196b1324",
  null
  
)

export default component.exports